var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Calculator',{attrs:{"type":1,"title":"Beef","summary":"Calculate the approximate stocking rate of cattle using the fields below","ispecifyAllowance":30,"ibreeds":[
    { name: '200kg lightweight steer', allowance: 8 },
    { name: '400kg lightweight steer', allowance: 12 },
    { name: 'Dry cow', allowance: 10 },
    { name: 'Lactating cow (5 months)', allowance: 20 }
  ],"ipaddock":{
    size: 1,
    growthRate: 10,
    pastureStart: 2000,
    pastureEnd: 1200,
    daysGrazing: 10
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }